import React, { useEffect, useRef, useState } from 'react'
import './style.sass'
import PropTypes from 'prop-types'
import FieldWrapper from '../FieldWrapper'

const PasswordField = ({ displayName, placeholder, description, errorMessage, disabled, value, onChange, formIsDirty, isCreateNewModeDefault = false }) => {
  // ===== Local State =====
  const [showPassword, setShowPassword] = useState(false)
  const [isCreateNewMode, setIsCreateNewMode] = useState(isCreateNewModeDefault)

  // ===== Refs =====
  const fieldRef = useRef()

  // ===== Side Effects =====
  useEffect(() => {
    if (!formIsDirty && !isCreateNewModeDefault) {
      resetCreateNewMode()
    }
  }, [formIsDirty])

  // ===== Methods =====
  const handleCreateNew = () => {
    setIsCreateNewMode(true)
    setShowPassword(true)
    onChange("")
    setTimeout(() => fieldRef.current?.focus(), 200)
  }

  const resetCreateNewMode = () => {
    setIsCreateNewMode(false)
    setShowPassword(false)
  }

  return (
    <FieldWrapper
      displayName={displayName}
      description={description} 
      errorMessage={errorMessage}
      disabled={disabled}
    >
      <div className="password-field-container">
        <input
          ref={fieldRef}
          type={!showPassword ? 'password' : 'text'}
          placeholder={placeholder || displayName}
          value={value ?? ""}
          onChange={onChange ? (e) => onChange(e.target.value) : () => {}}
          disabled={disabled || !isCreateNewMode}
        />
        {(!isCreateNewMode && !disabled) ? (
          <button className='btn btn-no-fill create-new-btn' onClick={handleCreateNew}>
            Create New
          </button>
        ) : (
          <button className='btn btn-no-fill' onClick={() => setShowPassword(show => !show)}>
            <i className={`fa fa-eye${!showPassword ? '-slash' : ''}`}></i>
          </button>
        )}
      </div>
    </FieldWrapper>
  )
}

PasswordField.propTypes = {
  displayName: PropTypes.string,
  placeholder: PropTypes.string,
  description: PropTypes.string,
  errorMessage: PropTypes.string,
  disabled: PropTypes.bool,
  value: PropTypes.any,
  onChange: PropTypes.func,
  formIsDirty: PropTypes.bool,
  isCreateNewModeDefault:  PropTypes.bool,
}

export default PasswordField
